import React from "react";
import {Box, Text, Table, TableProps, Loader, LoadingOverlay} from "@mantine/core";
import classes from "./ProtocolFileManager.module.css";
import {formatFileSize} from "@/common/utils/fileUtils";
import {UnifiedFileEntry} from "../hooks/useUnifiedFiles";
import {FileStatusCell} from "./FileStatusCell";
import {FileActionsCell} from "./FileActionsCell";
import {IProtocolRawFile} from "@/protocols/types/IProtocolRawFile.ts";
import {TWorkflow} from "@/protocols/common/steps/StepView.tsx";

interface FileStatusTable {
    unifiedFiles: UnifiedFileEntry[]
    onDelete: (file: IProtocolRawFile) => Promise<void>
    workflow: TWorkflow,
    loading?: boolean
}

export const FileStatusTable: React.FC<FileStatusTable> = ({
                                                               unifiedFiles,
                                                               onDelete,
                                                               workflow,
                                                               loading = false,
                                                           }) => {
    const tableProps: Partial<TableProps> = {striped: true};
    const readonly = workflow !== 'session';

    const renderLoading = () => {

        return (<LoadingOverlay visible={true} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />)
    }
    return (
        <Box className={classes.tableContainer} pos={"relative"}>
            {loading && renderLoading()}
            <Table {...tableProps} className={classes.table}>
                <Table.Thead
                    style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "var(--bios-medium-blue-0)",
                    }}>
                    <Table.Tr>
                        {!readonly && <Table.Th style={{width: "20%"}}>Status</Table.Th>}
                        <Table.Th style={{width: "60%"}}>File Name</Table.Th>
                        <Table.Th style={{width: "10%"}}>Size</Table.Th>
                        {!readonly && <Table.Th style={{width: "10%"}}>Actions</Table.Th>}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {unifiedFiles.length > 0 ? (
                        unifiedFiles.map((entry) => (
                            <Table.Tr style={{height: "3em"}} key={entry.id}>
                                {!readonly && < Table.Td><FileStatusCell entry={entry}/></Table.Td>}
                                <Table.Td>
                                    <Text size="sm">
                                        {entry.filename}
                                    </Text>
                                </Table.Td>
                                <Table.Td>
                                    <Text size="sm">{entry.size ? formatFileSize(entry.size) : "pending"}</Text>
                                </Table.Td>
                                {!readonly &&
                                    <Table.Td style={{textAlign: "center"}}>
                                        <FileActionsCell entry={entry} onDelete={onDelete}/>
                                    </Table.Td>
                                }
                            </Table.Tr>
                        ))
                    ) : null}
                </Table.Tbody>
            </Table>
        </Box>
    );
}